import React from 'react';
import { Link } from '@reach/router';
import { Card, CardCol, CardRow, C } from '@kineticdata/bundle-common';

export const AppendixCard = ({ appendix, path, components, ...props }) => (
  <Card {...props} to={path} components={{ Link, ...(components || {}) }}>
    <CardRow>
      <CardCol type={['prepend', 'icon']} className="my-2">
        <span
          className={`${appendix.values['Icon'] ||
            C.ICON_APPENDIX} fa-md text-muted`}
        />
      </CardCol>
      <CardCol>
        <CardRow type="title" className="">
          {appendix.values['Name']}
        </CardRow>
        <CardRow className="text-muted">
          {appendix.values['Short Description']}
        </CardRow>
      </CardCol>
    </CardRow>
  </Card>
);
